import { Button, Card, Divider, IconWrapper } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { ArrowRightMd, LayerTriple } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./SearchResultCard.module.css";
import type { SearchResultCardProps } from "./SearchResultCard.types";

export const SearchResultCard: FC<SearchResultCardProps> = ({
  title,
  subtitle,
  data,
  onClick,
}) => {
  const { t } = useCustomTranslation("main");

  return (
    <Card className={classes.container} size="sm">
      <div className={classes.header}>
        <div className={classes.title}>
          <IconWrapper role="presentation" size="md" src={LayerTriple} />
          <div>
            <h2 className="font-title-xs">{title}</h2>
            <p className="font-caption">{subtitle}</p>
          </div>
        </div>

        <Button endIcon={ArrowRightMd} onClick={onClick} variant="tertiary">
          {t("searchDrawer.result.button")}
        </Button>
      </div>

      {data && data?.length > 0 && (
        <>
          <Divider className={classes.divider} />
          <ul className={classes.list}>
            {data.map((item) => (
              <li key={item.name} className={classNames(classes.listItem)}>
                <span
                  className={classNames(
                    classes.itemValue,
                    "font-label-default",
                  )}
                >
                  {item.name}
                </span>
                <span
                  className={classNames(
                    classes.itemValue,
                    "font-label-highlight",
                  )}
                >
                  {item.value}
                </span>
                {item.subtitle && (
                  <span
                    className={classNames(
                      classes.itemValue,
                      "font-label-default",
                    )}
                  >
                    {item.subtitle}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </Card>
  );
};
